import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { Logo } from "@/components/Logo";
import { SocialLinks } from "@/components/SocialLinks";
import { WHATSAPP_URL } from "@/lib/api";

export const Footer = () => (
  <footer className="border-t border-[#E8E1D7]">
    <div className="mx-auto flex max-w-7xl flex-col gap-6 px-4 py-10 sm:px-6 md:flex-row md:items-center md:justify-between lg:px-8">
      <div>
        <Logo />
        <p className="mt-2 text-sm text-[#6E655F]">Marketing con IA y corazón para emprendedoras.</p>
        <div className="mt-4"><SocialLinks withLabel /></div>
      </div>
      <div className="flex flex-wrap items-center gap-6 text-sm text-[#6E655F]">
        <span>© {new Date().getFullYear()} LATINA DIGITAL IA</span>
        <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-[#E05A47]">Acceso equipo</Link>
      </div>
    </div>
  </footer>
);

export const WhatsAppButton = () => (
  <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" data-testid="whatsapp-float-button" aria-label="Escríbenos por WhatsApp"
    className="group fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full bg-[#25D366] p-4 text-white shadow-xl transition-transform duration-300 hover:scale-105">
    <MessageCircle className="h-6 w-6" />
    <span className="hidden max-w-0 overflow-hidden whitespace-nowrap text-sm font-semibold transition-[max-width] duration-300 group-hover:max-w-[200px] sm:inline">
      ¿Hablamos?
    </span>
  </a>
);
